import { VehicleModel } from '@/lib/models/vehicle/types';
import { getVehicleName } from '@/lib/models/vehicle/utils/get-vehicle-name';

export const getVehicleNames = (vehicles: VehicleModel[]): string => {
  return vehicles.map((vehicle) => getVehicleName(vehicle)).join(', ');
};
